<template>
	<div class="search">
		<input
			v-if="!value.idProduct"
			@focus="searchProduct"
			@input="searchProduct"
			@blur="onBlur"
			aria-label="제품명 검색"
			:placeholder="getSearchStatus.placeholder"
			:disabled="!getSearchStatus.status"
			type="text"
			class="search__input"
		/>
		<input
			v-if="value.idProduct"
			:value="`(${value.idProduct}) ${value.productTitle}`"
			aria-label="선택된 제품"
			type="text"
			readonly
			class="search__input search__selected"
		/>
		<button
			@click="initSelection"
			v-if="value.idProduct"
			class="btn search__clear"
		>
			삭제
		</button>
		<div v-if="getProducts.length > 0" class="search__product-selector">
			<ul>
				<li
					v-for="product in getProducts"
					:key="product.idProduct"
					v-html="product.title"
					class="search__product-selector__list__item product"
					@click="selectProduct(product)"
				/>
			</ul>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash';
	import { stringify } from 'query-string';

	export default {
		name: 'SearchProductByCategory',
		props: {
			value: {
				type: Object,
				default() {
					return {
						title: '',
						idProduct: null,
					};
				},
			},
			categoryIds: {
				type: Object,
				default() {
					return {
						idFirstCategory: null,
						idSecondCategory: null,
						idThirdCategory: null,
						thirdCategoryLength: 0,
					};
				},
			},
		},
		data() {
			return {
				products: [],
				blurTimer: null,
			};
		},
		watch: {
			categoryIds() {
				this.initSelection();
			},
		},
		computed: {
			getProducts() {
				return this.products;
			},
			getSearchStatus() {
				if (
					this.categoryIds.idFirstCategory &&
					this.categoryIds.idSecondCategory &&
					(this.categoryIds.thirdCategoryLength === 0 ||
						this.categoryIds.idThirdCategory)
				) {
					return {
						status: true,
						placeholder: '제품을 선택해 주세요',
					};
				} else {
					this.products = [];

					return {
						status: false,
						placeholder: '카테고리를 먼저 선택해 주세요',
					};
				}
			},
		},
		methods: {
			searchProduct: _.debounce(function (event) {
				const params = {
					firstCategoryV2Id: this.categoryIds.idFirstCategory,
					secondCategoryV2Id: this.categoryIds.idSecondCategory,
					thirdCategoryV2Id:
						this.categoryIds.idThirdCategory === 'all'
							? null
							: this.categoryIds.idThirdCategory,
					showMergedChildren:
						this.categoryIds.idThirdCategory === 'all',
					searchProductTitle: event.target.value,
				};

				this.$axiosAdmin2
					.get(`/api/categories/v2/products?${stringify(params)}`)
					.then(({ data }) => {
						this.products = data.map(item => ({
							...item,
							title: _.compact([
								`[${item.idProduct}/${item.brandTitle}]`,
								item.isDisplay
									? ''
									: '<span class="product__label">[비전시]</span>',
								item.isDiscontinue
									? '<span class="product__label">[단종]</span>'
									: '',
								item.productTitle,
							]).join(' '),
						}));
					})
					.catch(({ response }) => {
						console.error(response);
					});
			}, 500),
			selectProduct(product) {
				this.products = [];
				this.$emit('input', product);
			},
			initSelection() {
				this.$emit('input', {
					idProduct: null,
					title: '',
				});
			},
			onBlur() {
				if (this.blurTimer) {
					clearTimeout(this.blurTimer);
				}

				this.blurTimer = setTimeout(() => {
					this.products = [];
				}, 500);
			},
		},
	};
</script>
<style lang="scss">
	DIV.search {
		position: relative;

		.search__input {
			display: inline-block;
			width: 400px;
		}

		.search__selected {
			border: 0;
		}

		.btn {
			display: inline-block;
			vertical-align: middle;
		}

		.search__product-selector {
			position: absolute;
			overflow: scroll;
			z-index: 999;
			width: 400px;
			min-height: 100px;
			max-height: 300px;
			background-color: #fff;
			border: solid 1px #dfe6ee;
			border-radius: 5px;
			padding: 1em 0.5em;

			li {
				padding: 1em 0.5em;
				cursor: pointer;

				&:hover {
					color: #fff;
					font-weight: bold;
					background-color: #0099fa;
				}
			}
		}

		.product__label {
			color: #e31b1b;
			font-weight: bold;
		}
	}
</style>
